import {combineReducers} from "redux";
import result from "./result";
import draw from "./draw";
const resultMtReducer = combineReducers({
    result, draw
});

export default resultMtReducer;
